import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface EditKpiState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null | undefined
  data: undefined
}

const initialState: EditKpiState = {
  isLoading: false,
  error: null,
  httpStatus: null,
  data: undefined
}

const editKpiSlice = createSlice({
  name: 'editCustomKpiSlice',
  initialState,
  reducers: {
    editKpiLoadingAction: (state) => {
      return {
        ...state,
        isLoading: true,
        error: null,
        httpStatus: 0,
        data: undefined
      }
    },
    editKpiUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        data: action.payload.data
      }
    },
    editKpiErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        data: undefined
      }
    },
    updateKpiReset: () => initialState
  }
})

export const {
  editKpiLoadingAction,
  editKpiUpdateAction,
  editKpiErrorAction,
  updateKpiReset
} = editKpiSlice.actions

export default editKpiSlice.reducer
